import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6ce5aaea"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "bg-brand-dark min-h-fit md:min-h-full text-white" };
const _hoisted_2 = { class: "flex flex-row ml-4 md:justify-center py-8" };
const _hoisted_3 = ["src"];
const _hoisted_4 = { class: "flex-1 md:hidden" };
const _hoisted_5 = { class: "min-h-fit" };
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Dashboard", -1));
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Bookings", -1));
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Customers", -1));
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Employees", -1));
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Locations", -1));
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Reporting", -1));
import { CalendarIcon, LocationMarkerIcon, UserIcon, MenuIcon, ChartBarIcon, DocumentReportIcon } from "@heroicons/vue/outline";
import { ref, inject } from "vue";
import { useAuthentication } from "@/stores/authentication";
export default /*#__PURE__*/ _defineComponent({
    setup(__props) {
        const isImpress = inject('impress');
        const { hasPermission } = useAuthentication();
        const burger = ref(false);
        function onClickBurger() {
            burger.value = !burger.value;
        }
        var oldWidth = window.innerWidth;
        window.addEventListener("resize", onResize);
        function onResize() {
            // No burger menu, keep the nav open
            if (window.innerWidth >= 768) {
                burger.value = true;
                // Burger menu, let's close it if it's a fresh squeeze.
            }
            else if (oldWidth >= 768) {
                burger.value = false;
            }
            oldWidth = window.innerWidth;
        }
        onResize();
        return (_ctx, _cache) => {
            const _component_RouterLink = _resolveComponent("RouterLink");
            return (_openBlock(), _createElementBlock("aside", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("img", {
                        class: _normalizeClass(_unref(isImpress) ? 'w-full mx-4' : 'w-24'),
                        src: _unref(isImpress) ? '/images/logo-impress.svg' : '/images/logo.svg',
                        alt: "Logo"
                    }, null, 10, _hoisted_3),
                    _createElementVNode("div", _hoisted_4, [
                        _createVNode(_unref(MenuIcon), {
                            class: "float-right mr-4 w-16",
                            onClick: onClickBurger
                        })
                    ])
                ]),
                _withDirectives(_createElementVNode("nav", _hoisted_5, [
                    (_unref(hasPermission)('manage bookings'))
                        ? (_openBlock(), _createBlock(_component_RouterLink, {
                            key: 0,
                            "exact-active-class": "active",
                            to: { name: 'dashboard.view' }
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_unref(ChartBarIcon), { class: "icon" }),
                                _hoisted_6
                            ]),
                            _: 1
                        }, 8, ["to"]))
                        : _createCommentVNode("", true),
                    _createVNode(_component_RouterLink, {
                        "exact-active-class": "active",
                        to: { name: 'bookings.list' }
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_unref(CalendarIcon), { class: "icon" }),
                            _hoisted_7
                        ]),
                        _: 1
                    }, 8, ["to"]),
                    _createVNode(_component_RouterLink, {
                        "exact-active-class": "active",
                        to: { name: 'customers.list' }
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_unref(UserIcon), { class: "icon" }),
                            _hoisted_8
                        ]),
                        _: 1
                    }, 8, ["to"]),
                    (_unref(hasPermission)('manage employees'))
                        ? (_openBlock(), _createBlock(_component_RouterLink, {
                            key: 1,
                            "exact-active-class": "active",
                            to: { name: 'employees.list' }
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_unref(UserIcon), { class: "icon" }),
                                _hoisted_9
                            ]),
                            _: 1
                        }, 8, ["to"]))
                        : _createCommentVNode("", true),
                    _createVNode(_component_RouterLink, {
                        "exact-active-class": "active",
                        to: { name: 'locations.list' }
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_unref(LocationMarkerIcon), { class: "icon" }),
                            _hoisted_10
                        ]),
                        _: 1
                    }, 8, ["to"]),
                    (_unref(hasPermission)('manage reportings'))
                        ? (_openBlock(), _createBlock(_component_RouterLink, {
                            key: 2,
                            "exact-active-class": "active",
                            to: { name: 'reportings.list' }
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_unref(DocumentReportIcon), { class: "icon" }),
                                _hoisted_11
                            ]),
                            _: 1
                        }, 8, ["to"]))
                        : _createCommentVNode("", true)
                ], 512), [
                    [_vShow, burger.value]
                ])
            ]));
        };
    }
});
